<template minapp='mpx' xlang='wxml'>
  <view class="card-wrap" wx:style="{{customStyle}}">
    <view class="card-wrap-gradual" wx:if="{{showGradual}}"></view>
    <view class="card-wrap-content card-wrap-content1" wx:if="{{showGradual}}">
      <slot />
    </view>
    <view class="card-wrap-content" wx:else>
      <slot />
    </view>
  </view>
  <!-- 用法举例 -->
  <!-- <card-wrap1 showGradual>卡片主体【有】渐变背景</card-wrap1> -->
  <!-- <card-wrap1>卡片主体【无】渐变背景</card-wrap1> -->
</template>

<script>
import { createComponent } from '@mpxjs/core'
createComponent({
  props: {
    showGradual: {
      type: Boolean,
      value: false,
    },
    customStyle: null,
  },
  methods: {},
  // 组件生命周期函数-在组件布局完成后执行)
  created() {},
})
</script>

<style lang="stylus" scoped>
.card-wrap {
  margin: 10px 12px;
  // box-shadow: 0px 8px 24px 0px rgba(30, 51, 79, 0.08);
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;

  // border: solid 1px #707070;
  &-gradual {
    height: 44px;
    border-radius: 8px 8px 0 0;
    background-image: linear-gradient(0deg, #ffffff 0%, #cbe0ff 100%);
  }

  &-content1 {
    margin-top: -27px;
    padding: 0;
  }
}
</style>

<script name="json">
module.exports = {
  component: true,
}
</script>
